import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { BaseHttpService } from './basehttp.service';
import { Constants } from '../constants';
import { StorageService } from './token-storage.service';
import { MenubarService } from './menunavbar.services';
import { GlobalsessionhandlerService } from './globalsessionhandler.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LogoutServive } from 'src/app/logout/logout.service';
import { UserServiceService } from 'src/app/user/survey-main/service/user-service.service';
import { MatDialog } from '@angular/material/dialog';
import { GroupMappingDialogComponent } from 'src/app/login/group-mapping-dialog/group-mapping-dialog.component';
import { NotificationService } from './notifications.service';

@Injectable({
  providedIn: 'root',
})
export class PostLoginService {

  private constants: Constants = new Constants();

  constructor(
    private baseHttpService: BaseHttpService,
    private storage: StorageService,
    private router: Router,
    private menubarService: MenubarService,
    private globalsessionhandler: GlobalsessionhandlerService,
    private spinnerService: NgxSpinnerService,
    private logoutservice: LogoutServive,
    private userService: UserServiceService,
    private dialog: MatDialog,
    private notificationService: NotificationService
  ) {}

  /**
   * Runs the full post-login setup: creates user in DB if needed,
   * checks group mapping, fetches user details, and navigates to homePage.
   * @param userEmail The authenticated user's email address.
   */
  async handlePostLoginSetup(userEmail: string): Promise<void> {
    this.spinnerService.show();
    this.storage.set('Useremail', userEmail);

    // Create user in DB if not exists
    const creationResult = await this.getOrCreateUser();
    if (creationResult != null) {
      this.storage.set('LoggedInUserAgencyId', creationResult['agencyId']);
    }
    if (creationResult == false) {
      this.spinnerService.hide();
      return;
    }

    // Check group mapping and fetch user details
    await new Promise<void>((resolve) => {
      this.checkUserGroupMapping(userEmail).subscribe(
        (mapAvailable: boolean) => {
          if (!mapAvailable) {
            this.openGroupMappingDialog();
            this.spinnerService.hide();
            resolve();
          } else {
            this.globalsessionhandler.clearSession();
            this.globalsessionhandler.emitloginSucessful(true);

            this.baseHttpService.get(this.constants.getUser).subscribe(result => {
              if (result != null) {
                this.userService.getUserDeatils(result);
                const loginname = result.fullName.split(',');
                this.storage.set('LoggedInuserId', JSON.stringify(result.customerId));
                this.storage.set('LoggedInuserMailId', result.email);
                this.storage.set('LoggedInUserTypeId', result.userTypeId);
                this.storage.set('LoggedInUserTypeDesc', result.userTypeDesc);
                this.storage.set('LoggedInuserFirstName', loginname[1]);
                this.storage.set('LoggedInUserAgency', result.userAgency);
                this.storage.set('LoggedInProviderType', result.providerType);
                this.globalsessionhandler.setLoggedInUserName(loginname[1].trim() + ', ' + loginname[0].trim());
                this.globalsessionhandler.setUserGroupId(result.userGroupId);
                this.storage.set('UserGroupId', result.userGroupId);

                this.logoutservice.changeMessage(true);
                this.menubarService.updatedDataSelection(true);
                this.logoutservice.setUserLoginStatus(true);
                this.router.navigate(['/homePage']);
              }
              this.spinnerService.hide();
              resolve();
            });
          }
        },
        () => {
          this.spinnerService.hide();
          resolve();
        }
      );
    });
  }

  getOrCreateUser(): Promise<any> {
    return new Promise<any>((resolve) => {
      this.baseHttpService.get(this.constants.GetOrCreateUser).subscribe(
        result => {
          resolve(result != null ? result : false);
        },
        error => {
          if (error.status === 401 || error.status === 403) {
            this.notificationService.showError(
              'You are not authorized to access this application. Please contact your Admin',
              'Unauthorized Access'
            );
          }
          resolve(false);
        }
      );
    });
  }

  checkUserGroupMapping(email: string): Observable<boolean> {
    const subject = new Subject<boolean>();
    this.baseHttpService.getById(this.constants.getUserGroupMapping, email).subscribe(
      (result: boolean) => {
        subject.next(result);
        subject.complete();
      },
      (error) => {
        subject.error(error);
      }
    );
    return subject.asObservable();
  }

  openGroupMappingDialog(): void {
    const dialogRef = this.dialog.open(GroupMappingDialogComponent, {
      width: '400px',
      height: '300px',
    });
    dialogRef.afterClosed().subscribe(() => {
      console.log('The dialog was closed');
    });
  }
}
